import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '@components/Common/ScrollToTop';

const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // Disable right-click context menu site-wide (basic image/content protection)
    useEffect(() => {
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    return (
        <div id={`wrapper`}>
            <Header/>
            <section id="content">
                {children}
            </section>
            <Footer/>
            <ScrollToTop />
        </div>
    );
};

export default Layout;